import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  container: {
    width: "100%"
  },
  input: {
    marginTop: 1,
  },
};
